<template>
  <div class="template">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Vega',
}
</script>
<style lang="scss">
.template{
  background: #E5E5E5;
}
</style>
